export function statusCalc(campaign) {   
    if(campaign.must_archive) {
        return 'archived';
    }                     
    if(campaign.status === 'released') {
        let startdatetime = new Date(campaign.startdatetime);   
        let enddatetime = new Date(campaign.enddatetime);             
        if(enddatetime <= Date.now() ) {
            return 'completed';
        }
        else if(startdatetime <= Date.now() ) {
            return 'running';
        }
        else {
            return 'queued';
        }
    }            
    else if (campaign.status === 'completed') {
        let enddatetime = new Date(campaign.enddatetime);                
        if(enddatetime <= Date.now()) {
            return 'completed';
        }
        else {
            return 'stopped';
        }
    }
    if(campaign.is_proposal) {
        if(campaign.status === 'draft') {
            return 'proposal';
        }
        if(campaign.status === 'archived') {
            return 'rejected';
        }
    }
    return campaign.status;
}

export function getOptionDescription(optionList, optionValue){
    let matchedItem = optionList.find(o=>o.value===optionValue);
    let rslt = optionValue
    if(matchedItem) {
        rslt = matchedItem.text;
    }
    return rslt;
}

export function debounce(fn, wait){
    let timer;
   return function(...args){
     if(timer) {
        clearTimeout(timer); // clear any pre-existing timer
     }
     const context = this; // get the current context
     timer = setTimeout(()=>{
        fn.apply(context, args); // call the function if time expires
     }, wait);
   }
}

export function throttle(fn, wait){
    let throttled = false;
    return function(...args){
        if(!throttled){
            fn.apply(this,args);
            throttled = true;
            setTimeout(()=>{
                throttled = false;
            }, wait);
        }
    }
}